import styled from 'styled-components';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BulletIcon } from '@m/alchemy-ui/icons/BulletIcon';
import { Pill } from '@m/alchemy-ui/Pill';
import { color } from '@m/alchemy-ui/theme';
import * as Styled from 'settings/components/SettingsDashboardItem/SettingsDashboardItem.styled';
import { fetchSurveyConfigurations } from 'admin/company/surveys/reducers/surveysTableState';
import { SettingsDashboardItemProps } from '../SettingsDashboardItem';
import { SettingsDashboardItemIcon } from '../SettingsDashboardItem/SettingsDashboardItem';

const UnpublishedSurveysIndicator = styled.div`
  width: 24px;
  height: 24px;
  color: white;
  background: ${color('base', { palette: 'illustrativeRed' })};
  border-radius: 50%;
  z-index: 1;
  right: -12px;
  top: -12px;
`;

const SERVICE_RECOVERY_SURVEY = 'Service Recovery';
export function SurveyBuilderDashboardItem({
  id,
  link,
  title,
  subtitle,
}: SettingsDashboardItemProps): JSX.Element {
  const dispatch = useDispatch();
  const isButton = link === undefined || !link;
  // @ts-expect-error
  const configurations = useSelector(state => state.surveysTableState.surveys);
  const dirtyConfigurations = configurations.filter(
    ({ name, publishedHash, configurationHash }) => {
      if (id === 'survey_builder') {
        return (
          name !== SERVICE_RECOVERY_SURVEY &&
          publishedHash !== configurationHash
        );
      } else {
        return (
          name === SERVICE_RECOVERY_SURVEY &&
          configurationHash &&
          publishedHash !== configurationHash
        );
      }
    }
  );

  useEffect(() => {
    dispatch(fetchSurveyConfigurations());
  }, [dispatch]);

  return (
    <>
      <Styled.AnchorContainer
        as={isButton ? 'button' : undefined}
        href={isButton ? undefined : link}
      >
        <Styled.ItemContainer
          hoverDepth={20}
          depth="moduleChrome"
          className="relative"
        >
          {dirtyConfigurations?.length > 0 && (
            <UnpublishedSurveysIndicator className="flex align-center justify-center font-size-smallish absolute font-weight-xlarge">
              {dirtyConfigurations.length}
            </UnpublishedSurveysIndicator>
          )}
          <Styled.IconLabelContainer>
            <SettingsDashboardItemIcon id={id} />
            <Styled.Title>{title}</Styled.Title>
          </Styled.IconLabelContainer>

          <Styled.Subtitle>{subtitle}</Styled.Subtitle>
          {dirtyConfigurations?.length > 0 && (
            <Pill
              palette="illustrativeOrange"
              fontSize={12}
              className="font-weight-largish inline-flex align-center"
            >
              <BulletIcon
                palette="illustrativeOrange"
                color="base"
                aria-hidden="true"
              />
              Unpublished changes
            </Pill>
          )}
        </Styled.ItemContainer>
      </Styled.AnchorContainer>
    </>
  );
}
